import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Smartphone, Check, Loader2 } from "lucide-react";
import { API } from "../../App";
import { PAYMENT_OPERATORS, ALL_OPERATOR_IDS } from "../../lib/payments";

export function SettingsPayments({ getAuthHeaders, accent }) {
  const [selected, setSelected] = useState(ALL_OPERATOR_IDS);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    axios.get(`${API}/settings`, getAuthHeaders())
      .then((r) => { const ops = r.data?.payment_operators; if (Array.isArray(ops) && ops.length) setSelected(ops); })
      .catch(() => {});
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const toggle = (id) => setSelected((prev) => prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]);

  const save = async () => {
    if (selected.length === 0) { toast.error("Gardez au moins un opérateur"); return; }
    setSaving(true);
    try {
      await axios.put(`${API}/settings/payment-operators`, { payment_operators: selected }, getAuthHeaders());
      toast.success("Moyens de paiement mis à jour");
    } catch { toast.error("Erreur lors de la sauvegarde"); }
    finally { setSaving(false); }
  };

  return (
    <div className="s-card" data-testid="payments-section">
      <div className="s-card-header">
        <div className="s-card-title-row">
          <Smartphone size={18} style={{ color: accent }} />
          <h2 className="s-card-title">Moyens de paiement acceptés</h2>
        </div>
        <button className="s-accent-btn" onClick={save} disabled={saving} data-testid="payments-save-btn">
          {saving ? <Loader2 size={14} className="animate-spin" /> : <Check size={14} />} Enregistrer
        </button>
      </div>
      <p style={{ fontSize: 12, color: '#6B7280', margin: '0 0 12px' }}>
        Les opérateurs cochés apparaissent dans la caisse quand le vendeur choisit « Carte / Mobile Money ». Les espèces sont toujours disponibles.
      </p>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(150px, 1fr))', gap: 8 }}>
        {PAYMENT_OPERATORS.map((op) => {
          const on = selected.includes(op.id);
          return (
            <button key={op.id} type="button" onClick={() => toggle(op.id)} data-testid={`payment-op-toggle-${op.id}`}
              style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '10px 12px', borderRadius: 10, cursor: 'pointer', textAlign: 'left',
                border: `1px solid ${on ? op.color : 'rgba(128,128,128,0.25)'}`, background: on ? `${op.color}22` : 'transparent', opacity: on ? 1 : 0.55 }}>
              <span style={{ width: 12, height: 12, borderRadius: 999, background: op.color, flexShrink: 0 }} />
              <span style={{ fontSize: 13, fontWeight: 600, flex: 1 }}>{op.label}</span>
              {on && <Check size={14} style={{ color: accent }} />}
            </button>
          );
        })}
      </div>
    </div>
  );
}
